const tenantSettingsPaths = {
	"portal-branding": "/fulfill/portal/branding",
	"portal-settings": "/fulfill/portal/settings",
	settings: "/produce/settings",
	"settings-general": "/fulfill/settings/general",
	"settings-index": "/fulfill/settings"
};

const canOpenTenantSettings = (path: string, canManageSettings: boolean): boolean => {
	const pathname = path.trim().split(/[?#]/)[0].replace(/\/$/, "");
	return canManageSettings || !Object.values(tenantSettingsPaths).includes(pathname);
};

const isTenantSettingsPageId = (pageId: string | undefined): boolean =>
	Object.keys(tenantSettingsPaths).includes(pageId ?? "");

export { isTenantSettingsPageId, tenantSettingsPaths };
export default canOpenTenantSettings;
